module.exports = __webpack_public_path__ + "static/img/sx02.598b12e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sx02.png
// module id = XLYo
// module chunks = 0